import React from 'react'
import {
  Container,
  Header,
  Icon,
} from 'semantic-ui-react'

const Contact = () => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>Contact Us</Header>
    <p>
      This is an unofficial web application.
      We did not design the CS2013 curriculum.
      We just developed this web application
      and converted the official curriculum document into a format the application can read.
    </p>
    <p>
      If you have feedback on the contents of the curriculum,
      please contact the authors of the original document
      (<a href="https://www.acm.org/education/curricula-recommendations">see the ACM curricula recommendations web page</a>).
    </p>
    <p>
      If you have feedback on the way this web application presents the curriculum,
      or if you believe that we made a mistake in converting the official document,
      please do contact us:
    </p>
    <p>
      <Icon name="mail"/><a href="mailto:matthias.hauswirth@usi.ch">matthias.hauswirth@usi.ch</a>
    </p>
  </Container>
)

export default Contact